import { PARTNERS_IDS } from 'constants/partners';

import { AvitoStylesWrapper } from '../ui/StylesWrapper/AvitoStylesWrapper';
import { BipStylesWrapper } from '../ui/StylesWrapper/BipStylesWrapper';

export const PARTNERS_CUSTOM_THEME = {
  [PARTNERS_IDS.avito]: { themeName: 'avito-light', Component: AvitoStylesWrapper },
  [PARTNERS_IDS.bip]: { themeName: 'lager', Component: BipStylesWrapper },
} as const;
